import { buildBuiltinScheme, buildSection } from './builder'

export const portraitScheme = buildBuiltinScheme(
  {
    id: 'builtin-portrait',
    name: '人像摄影 · 写实',
  },
  [
    buildSection('风格基调', 0, ['photorealistic portrait', 'editorial photography']),
    buildSection('主体 + 人设', 1, ['young east asian woman', 'mid twenties', 'confident posture']),
    buildSection('妆造 + 服饰', 2, ['minimal makeup', 'black tailored blazer', 'silver earrings']),
    buildSection('表情与姿态', 3, ['subtle smile', 'looking slightly off-camera']),
    buildSection('环境 / 背景', 4, ['blurred urban street', 'neon bokeh']),
    buildSection('光线描述', 5, ['soft rim light', 'warm key light', 'cool background fill']),
    buildSection('镜头语言', 6, ['85mm', 'f/1.4', 'shallow depth of field', 'waist-up framing']),
    buildSection('质感与细节', 7, ['skin texture details', 'cinematic color grading']),
    buildSection('质量描述', 8, ['ultra detailed', '8k', 'award-winning portrait']),
  ],
  {
    ar: '4:5',
    v: '6.1',
    style: 'raw',
    q: 2,
    s: 300,
  },
)
